import React from 'react';
import styled, {css} from 'styled-components';
import presets from "../utils/presets";
import {rhythm} from "../utils/typography";

const Background = styled.div`
height:100%;
width:100%;
max-width: :100%;
overflow:hidden;
position:absolute;
align-items: center;
object-fit: cover;
top:0;
left:0;
video{
  display:flex;
  height:100%;
  width:100%;
  max-width: :100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  object-fit: cover;
  overflow: hidden;
}
${'' /* img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
} */}

`

export default Background



// WEBPACK FOOTER //
// ./src/com/Background.js